import { Injectable, EventEmitter } from '@angular/core';

import { LayoutSidebarComponent } from '../components/sidebar.component';

@Injectable()
export class LayoutSidebarService {

  public sidebars: SidebarObject = {
    left: null,
    right: null
  };

  private _temp_visible_flags = {
    left: false,
    right: false
  };

  public fixed = false;

  public onVisibilityChange: EventEmitter<LayoutSidebarComponent> = new EventEmitter();
  public onSideBarRegister: EventEmitter<SidebarObject> = new EventEmitter();
  public onSideBarUnregister: EventEmitter<SidebarObject> = new EventEmitter();

  public getSidebar(name: SidebarSide): LayoutSidebarComponent {
    return this.sidebars[name] || null;
  }

  public setFixed(fixed: boolean) {
    this.fixed = fixed || false;
  }

  public setVisible(side: SidebarSide, visible: boolean) {
    const sidebar = this.getSidebar(side);
    if (sidebar) {
      sidebar.setVisible(visible);
    } else {
      this._temp_visible_flags[side] = visible;
    }
  }

  public getVisible(side: SidebarSide): boolean {
    const sidebar = this.getSidebar(side);
    return sidebar ? sidebar.visible : false;
  }

  public toggleVisible(side: SidebarSide) {
    const sidebar = this.getSidebar(side);
    if (sidebar) { sidebar.toggleVisible(); }
  }

  public $registerSidebar(side: SidebarSide, sidebar: LayoutSidebarComponent): boolean {
    if (sidebar && !this.sidebars[side]) {
      this.sidebars[side] = sidebar;
      if (this._temp_visible_flags[side]) {
        sidebar.setVisible(this._temp_visible_flags[side]);
        this._temp_visible_flags[side] = null;
      }
      this.onSideBarRegister.emit(this.sidebars);
      return true;
    }

    return false;
  }

  public $unregisterSidebar(side: SidebarSide): boolean {
    if (side && this.sidebars[side]) {
      this.sidebars[side] = null;
      this.onSideBarRegister.emit(this.sidebars);
      return true;
    }

    return false;
  }

}

interface SidebarObject {
  left: LayoutSidebarComponent;
  right: LayoutSidebarComponent;
}

export type SidebarSide = 'left' | 'right';
